
import { css } from 'lit';
export default css`
pc-menu .is-hidden{
  display:none;
}

@media (min-width: 992px){
  pc-menu pc-menu-link[level='1'].is-hidden,
  pc-menu pc-menu-dropdown[level='1'].is-hidden{
    display:inherit;
  }

  .overlay-menu{
    display:none;
    position:fixed;
    top:0;
    right:0;
    bottom:0;
    left:0;
    opacity:0.15;
    z-index:1;
    background-color:var(--neutral-charcoal);
  }

  .overlay-menu.is-visible{
    display:block;
  }
}
`;